
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[categorySlug]",
      function () {
        return require("private-next-pages/[categorySlug].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[categorySlug]"])
      });
    }
  